;(function () {
  'use strict'

  angular
    .module('contrast.features')
    .constant('FEATURE_FLAGS_LOADED_EVENT', 'featureFlagsLoaded')
})()
